import { createBrowserClient } from '@magicschool/supabase/clients/browser';

export const clientSupabase = createBrowserClient({
  overrideFetch: async (input: string | URL | Request, init?: RequestInit) => {
    try {
      const response = await fetch(input, init);
      return response;
    } catch {
      throw new Error('Failed to fetch');
    }
  },
});

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export const untypedClientSupabase = clientSupabase as ReturnType<typeof createBrowserClient<any>>;
